/** @type {const} */
export const surveyTag = {
  ONBOARDING: 'onboarding',
  EVERYWHERE: 'everywhere',
  FLOATING: 'floating',
};

/** @type {const} */
export const surveyMode = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
  CTA: 'cta',
};

/** @type {const} */
export const floatingSurveyCadenceHours = {
  ACTIVE_PAYING: 96,
  DEFAULT: 24,
};

/** @type {const} */
export const floatingSurveyPostLoginDelayMs = 30_000;

/** @type {const} */
export const teachingLevelSurveyCode = 'teaching-level';

/** @type {const} */
export const teachingLevels = [
  { value: 'K-2', label: 'K-2' },
  { value: '3-5', label: '3-5' },
  { value: 'middle-school', label: 'Middle School' },
  { value: 'high-school', label: 'High School' },
  { value: 'higher-education', label: 'Higher Education' },
];

/** @type {const} */
export const [
  TL_K2,
  TL_35,
  TL_MiddleSchool,
  TL_HighSchool,
  TL_HigherEducation,
] = teachingLevels.map((tl) => tl.value);
